import { Reducer } from '@reduxjs/toolkit';
import { Route } from 'router5';

export type AppModule = {
  name: string;
  reducer?: Reducer;
  reducerPath?: string;
  routeDefs?: Route[];
};

export type ImportedAppModule = Promise<{ default: AppModule }>;

export const unwrapModules = (modules: ImportedAppModule[]) => {
  return Promise.all(
    modules.map((module) => module.then((module) => module.default)),
  );
};
